import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DashboardPage from "./pages/Dashboard";
import ViewBannersPage from "./pages/Banner/ViewBannersPage";
import AddBannerPage from "./pages/Banner/AddBannerPage";
import LoginPage from "./pages/Auth/LoginPage";
import VerifyOtpPage from "./pages/Auth/VerifyOtpPage";
import ChangePasswordPage from "./pages/Auth/ChangePasswordPage";
import BusinessLoginPage from "./pages/Auth/BusinessLoginPage";
import BusinessChangePasswordPage from "./pages/Auth/BusinessChangePasswordPage";
import BusinessChangePassword from "./pages/Business/BusinessChangePassword";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/Auth/ResetPasswordPage";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import ProtectedLayout from "./routes/ProtectedLayout";
import BusinessProtectedRoute from "./routes/BusinessProtectedRoute";
import BusinessPublicRoute from "./routes/BusinessPublicRoute";
import BusinessProtectedLayout from "./routes/BusinessProtectedLayout";
import BusinessDashboard from "./pages/Business/BusinessDashboard";
import BusinessSettings from "./pages/Business/BusinessSettings";
import BusinessDiscount from "./pages/Business/BusinessDiscount";
import TransactionInitiate from "./pages/Business/TransactionInitiate";
import TransactionHistory from "./pages/Business/TransactionHistory";
import ViewBussinessPage from "./pages/Businesses/ViewBussinessPage";
import AddBussinessWizard from "./pages/Businesses/AddBussinessPage";
import ViewCategoriesPage from "./pages/Categories/ViewCategoriesPage";
import AddCategoryPage from "./pages/Categories/AddCategoryPage";
import ViewSubCategoriesPage from "./pages/SubCategories/ViewSubCategoriesPage";
import AddSubCategoryPage from "./pages/SubCategories/AddSubCategoryPage";
import ViewCategoryServicesPage from "./pages/CategoryServices/ViewCategoryServicesPage";
import AddCategoryServicePage from "./pages/CategoryServices/AddCategoryServicePage";
import ViewStatesPage from "./pages/States/ViewStatesPage";
import AddStatePage from "./pages/States/AddStatePage";
import ViewDistrictsPage from "./pages/Districts/ViewDistrictsPage";
import AddDistrictPage from "./pages/Districts/AddDistrictPage";
import ViewTalukasPage from "./pages/Talukas/ViewTalukasPage";
import AddTalukaPage from "./pages/Talukas/AddTalukaPage";
import ViewSubscriptionPackagesPage from "./pages/SubscriptionPackages/ViewSubscriptionPackagesPage";
import AddSubscriptionPackagePage from "./pages/SubscriptionPackages/AddSubscriptionPackagePage";
import ViewPaymentModesPage from "./pages/PaymentModes/ViewPaymentModesPage";
import AddPaymentModePage from "./pages/PaymentModes/AddPaymentModePage";
import CompanyDetailsPage from "./pages/CompanyDetails/CompanyDetailsPage";
import ViewCustomersPage from "./pages/Customers/ViewCustomersPage";

export default function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route element={<BusinessPublicRoute />}>
          <Route path="/login" element={<BusinessLoginPage />} />
        </Route>
        {/* Admin Routes */}
        <Route element={<PublicRoute />}>
          <Route path="/admin/auth/login" element={<LoginPage />} />
          <Route path="/verify-otp" element={<VerifyOtpPage />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/change-password" element={<ChangePasswordPage />} />
            <Route path="/business" element={<ViewBussinessPage />} />
            <Route path="/business/add" element={<AddBussinessWizard />} />
            <Route path="/banners" element={<ViewBannersPage />} />
            <Route path="/banners/add" element={<AddBannerPage />} />
            <Route path="/categories" element={<ViewCategoriesPage />} />
            <Route path="/categories/add" element={<AddCategoryPage />} />
            <Route path="/sub-categories" element={<ViewSubCategoriesPage />} />
            <Route path="/sub-categories/add" element={<AddSubCategoryPage />} />
            <Route path="/category-services" element={<ViewCategoryServicesPage />} />
            <Route path="/category-services/add" element={<AddCategoryServicePage />} />
            <Route path="/states" element={<ViewStatesPage />} />
            <Route path="/states/add" element={<AddStatePage />} />
            <Route path="/districts" element={<ViewDistrictsPage />} />
            <Route path="/districts/add" element={<AddDistrictPage />} />
            <Route path="/talukas" element={<ViewTalukasPage />} />
            <Route path="/talukas/add" element={<AddTalukaPage />} />
            <Route path="/subscription-packages" element={<ViewSubscriptionPackagesPage />} />
            <Route path="/subscription-packages/add" element={<AddSubscriptionPackagePage />} />
            <Route path="/payment-modes" element={<ViewPaymentModesPage />} />
            <Route path="/payment-modes/add" element={<AddPaymentModePage />} />
            <Route path="/company-details" element={<CompanyDetailsPage />} />
            <Route path="/customers" element={<ViewCustomersPage />} />
          </Route>
        </Route>

        {/* Business Routes */}
        {/* <Route element={<BusinessPublicRoute />}>
          <Route path="/login" element={<BusinessLoginPage />} />
        </Route> */}

        {/* Forgot Password Routes - Public routes for password reset */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Business First-time Change Password - Standalone route for authenticated users who need to change password */}

        <Route element={<BusinessProtectedRoute />}>
          <Route element={<BusinessProtectedLayout />}>
            <Route path="/business/first-change-password" element={<BusinessChangePasswordPage />} />
            <Route path="/business/dashboard" element={<BusinessDashboard />} />
            <Route path="/business/transactions" element={<TransactionInitiate />} />
            <Route path="/business/transactions/history" element={<TransactionHistory />} />
            <Route path="/business/discount" element={<BusinessDiscount />} />
            <Route path="/business/settings" element={<BusinessSettings />} />
            <Route path="/business/change-password" element={<BusinessChangePassword />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
